<template>
  <!-- <product-details-cards :typeData="typeData"></product-details-cards> -->
  <product-details-cards-new :typeData="typeData"></product-details-cards-new>
</template>

<script>
  // 从fromLounge, fromSearch, fromBenifits页面来的
  // import ProductDetailsCards from '@/components/BaseUi/ProductDetailsCards/index.vue';
  import ProductDetailsCardsNew from '@/components/BaseUi/ProductDetailsCards/newIndex.vue';
  const type = 'lounge';
  export default {
    name: 'LoungeDetails',
    components: {
      // ProductDetailsCards,
      ProductDetailsCardsNew,
    },
    data() {
      return {
        typeData: null,
      };
    },
    created() {
      this.typeData = {
        lang: this.$i18n.locale,
        code: this.$route.query.loungeCode,
        type,
      };
    },
  };
</script>

<style></style>
